import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import cx from 'classnames';

type AdviceInformationProps = {
    description: string;
    disclaimer: string;
    brochure_url: string;
};

function getHTML(html: string) {
    return {
        __html: html,
    };
}

export default function AdviceInformation({
    description,
    disclaimer,
    brochure_url,
}: AdviceInformationProps) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    return (
        <div
            className={cx('advice-information', {
                'advice-information--open': isOpen,
            })}
        >
            <button
                className="advice-information__button"
                onClick={() => {
                    setIsOpen((prev) => !prev);
                }}
            >
                {t('More information on this product')}
            </button>
            <div className="advice-information__text">
                {description && (
                    <div dangerouslySetInnerHTML={getHTML(description)} />
                )}
                {disclaimer && (
                    <div dangerouslySetInnerHTML={getHTML(disclaimer)} />
                )}
                {brochure_url && (
                    <a
                        className="advice-information__download"
                        href={brochure_url}
                        target="_blank"
                        rel={'noreferrer'}
                    >
                        {t('Download brochure')}
                    </a>
                )}
            </div>
        </div>
    );
}
